export default __webpack_public_path__ + "img/30130d6f587bfb8e9ce04455ec15d924.svg";